export class Utils {
    available(tag) {
        const CustomElement = customElements.get(tag);
        if (CustomElement) {
            return CustomElement.version.toString() || 'unknown';
        }
        return '';
    }
}
